import { Component, Input } from '@angular/core';
import { Block } from '@core/models/block/block.model';

@Component({
    selector: '[app-button]',
    templateUrl: './button.component.html',
    standalone: false
})
export class ButtonComponent {
  @Input() block: Block;
}
